export default "__VITE_ASSET__DXiJQKBQ__"